import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

interface RouterContext {
  authorized: boolean;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      {/* {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />} */}
    </>
  );
}

